import { createStyledBreakpointsTheme } from 'styled-breakpoints'

export const getPrimaryTheme = (colorMode: 'light' | 'dark', tenant: Tenant) =>
  ({
    colorMode: colorMode,
    colorMain: colorMode === 'dark' ? '#2CA29F' : '#2CA29F',
    colorGrey: colorMode === 'dark' ? '#4d4d4d' : '#e4e6e9',
    colorGreyDark: colorMode === 'dark' ? '#4d4d4d' : '#a4a7ab',
    colorGreyLight: colorMode === 'dark' ? '#222222' : '#f4f4f4',
    colorText: colorMode === 'dark' ? '#d2d2d2' : '#121212',
    colorTextInverted: colorMode === 'dark' ? '#121212' : '#ffffff',
    colorSiteBackground: colorMode === 'dark' ? '#121212' : '#ffffff',
    tenant: tenant,
  })

export const getTheme = (colorMode: 'light' | 'dark', tenant: Tenant) => ({
  ...getPrimaryTheme(colorMode, tenant),
  ...createStyledBreakpointsTheme({
    breakpoints: {
      xs: '0px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
      xxl: '1400px',
      xxxl: '1580px',
    },
  }),
})
